import { HStack, Heading, Text, Icon, VStack, Image } from '@chakra-ui/react';
import { IoOpenOutline } from 'react-icons/io5';

import tzuchiDefaultImg from '~/assets/images/defaultImage.png';

export type LocationProps = {
  image: string;
  name: string;
  location: string;
  time: string;
  onClick: () => void;
};

// 歸還餐盒地點全部列表
export default function Location({ image, name, location, time, onClick }: LocationProps) {
  return (
    <HStack
      py={4}
      px={8}
      align="flex-start"
      spacing={6}
      borderWidth="1px"
      borderColor="gray.300"
      borderRadius="5px"
    >
      <Image borderRadius="full" boxSize="4rem" src={image || tzuchiDefaultImg} mt={5} />
      <VStack align="flex-start" spacing={2}>
        <Heading size="xs">{name}</Heading>
        <VStack align="stretch" spacing={1}>
          <Text fontSize="xs">{location}</Text>
          <Text fontSize="xs">{time}</Text>
        </VStack>
        <HStack align="flex-start" as="button" onClick={onClick}>
          <Text fontSize="xs" color="primary">
            查看取餐地點
          </Text>
          <Icon as={IoOpenOutline} boxSize="1rem" color="primary" />
        </HStack>
      </VStack>
    </HStack>
  );
}
